// Cây tổ chức lưu ở localStorage (chạy front-end trước, sau này thay bằng API)
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { seedOrg } from './orgSeed';
import type { RawNode } from './orgTree';

interface OrgState {
  tree: RawNode;
  setTree: (tree: RawNode) => void;
  reset: () => void;
}

const useOrgStore = create<OrgState>()(persist(set => ({
  tree: seedOrg,
  setTree: tree => set({ tree }),
  reset: () => set({ tree: seedOrg }),
}), { name: 'khothi-org-v1' }));

export default useOrgStore;
